// Crash fire ke 21 frames (fire_1 .. fire_21), ek baar chalne wala sequence
import f1 from '../assets/images/fire_1.png';
import f2 from '../assets/images/fire_2.png';
import f3 from '../assets/images/fire_3.png';
import f4 from '../assets/images/fire_4.png';
import f5 from '../assets/images/fire_5.png';
import f6 from '../assets/images/fire_6.png';
import f7 from '../assets/images/fire_7.png';
import f8 from '../assets/images/fire_8.png';
import f9 from '../assets/images/fire_9.png';
import f10 from '../assets/images/fire_10.png';
import f11 from '../assets/images/fire_11.png';
import f12 from '../assets/images/fire_12.png';
import f13 from '../assets/images/fire_13.png';
import f14 from '../assets/images/fire_14.png';
import f15 from '../assets/images/fire_15.png';
import f16 from '../assets/images/fire_16.png';
import f17 from '../assets/images/fire_17.png';
import f18 from '../assets/images/fire_18.png';
import f19 from '../assets/images/fire_19.png';
import f20 from '../assets/images/fire_20.png';
import f21 from '../assets/images/fire_21.png';

const FIRE_FRAMES = [f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12, f13, f14, f15, f16, f17, f18, f19, f20, f21];

export default FIRE_FRAMES;
